export default "__VITE_ASSET__CvZ8vtpY__"